const checkpointKey = 'app:microfrontend-load:v1'

type LoadingCheckpoint = {
  pageLoadId: string
  pageStartedAt: number
  total: number
  pending: number
  failed: number
}

const readPreviousCheckpoint = (): LoadingCheckpoint | undefined => {
  try {
    const stored = sessionStorage.getItem(checkpointKey)
    sessionStorage.removeItem(checkpointKey)
    return stored ? (JSON.parse(stored) as LoadingCheckpoint) : undefined
  } catch {
    return undefined
  }
}

export const createPageLoadDiagnostics = () => {
  const pageLoadId = crypto.randomUUID()
  const pageStartedAt = performance.timeOrigin
  const navigation = performance.getEntriesByType?.('navigation')[0] as PerformanceNavigationTiming | undefined
  const navigationType = navigation?.type ?? 'unknown'
  const previous = readPreviousCheckpoint()
  let checkpoint: LoadingCheckpoint | undefined
  let summaryReported = false

  const saveCheckpoint = () => {
    try {
      sessionStorage.setItem(checkpointKey, JSON.stringify(checkpoint))
    } catch {}
  }

  return {
    getContext: () => ({
      pageLoadId,
      clientTimestamp: new Date().toISOString(),
      pageElapsedMs: String(Math.round(performance.now())),
      navigationType
    }),
    startLoading: (total: number) => {
      checkpoint = { pageLoadId, pageStartedAt, total, pending: total, failed: 0 }
      saveCheckpoint()
    },
    recordResult: (failed: boolean) => {
      if (!checkpoint || checkpoint.pending === 0) return
      checkpoint.pending -= 1
      if (failed) checkpoint.failed += 1
      saveCheckpoint()
    },
    takeReloadSummary: () => {
      if (
        summaryReported ||
        navigationType !== 'reload' ||
        !previous ||
        (previous.pending === 0 && previous.failed === 0) ||
        !checkpoint ||
        checkpoint.pending !== 0
      ) {
        return undefined
      }
      summaryReported = true
      return {
        previous,
        previousPageElapsedMsAtReload: Math.max(0, Math.round(pageStartedAt - previous.pageStartedAt)),
        current: { ...checkpoint }
      }
    }
  }
}

export default createPageLoadDiagnostics()
